/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator>): AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator {
        let obj = Object.assign(new AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator(), model);
        AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator>): AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator {
        if (!model) return null;
        return AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator.newInstance(<AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator) {
        if (!obj) return;

        models.AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityExploitabilityMetricPrivilegesRequiredV31QueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Exploitability metric(s) privileges required v3.1 to include
     */
    privileges_required_v31: Array<models.Cvss31ExploitabilityPrivilegesRequired>;

}
